const FsfPages = {
    WITHOUT_SUCCESS_NOTIFICATION: 2,
    WITH_SUCCESS_NOTIFICATION: 3,
};

export { FsfPages };